// extracted by mini-css-extract-plugin
export default {"iconWrap":"ForumMessagesLink_iconWrap__bK+Lg","badge":"ForumMessagesLink_badge__6G9YR"};